import React, { useState } from 'react';
import { Box, Button, Typography, Input, Divider } from '@mui/material';
import { getStatsRecentAdvisors, getCompanyAdvisorsExport } from '../../services/admin_services';

const Stats = () => {
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [scannedPages, setScannedPages] = useState(0);
  const [totalAdvisors, setTotalAdvisors] = useState(0);
  const [totalAdvisorsWithRelations, setTotalAdvisorsWithRelations] =
    useState(0);

  return (
    <Box width="100%" p="12px">
      <Box width="100%" display="flex" justifyContent="space-between" mb="8px">
        <Typography variant="h5">Stats</Typography>
      </Box>
      <Box
        width="500px"
        mb="8px"
        display="flex"
        flexDirection="column"
        justifyContent="center"
      >
        <Typography variant="h2" mb="8px">
          Recently Joined Advisors
        </Typography>
        <Typography mb="8px">
          CAUTION: This will scan all the pages of the Advisor's table everytime
          you trigger the button
          <br />
          This will take a while, please be patient
          <br />
        </Typography>
        <Button
          variant="contained"
          color="error"
          disabled={loading}
          onClick={async () => {
            try {
              setLoading(true);
              let lastEvaluatedKey = null;
              do {
                const { data } = await getStatsRecentAdvisors({
                  LAST_EVALUATED_KEY: lastEvaluatedKey,
                });
                const result = data.getRecentCreatedAdvisors;

                setTotalAdvisors((prev) => prev + result.totalAdvisors);
                setTotalAdvisorsWithRelations(
                  (prev) => prev + result.totalAdvisorsInBoard
                );
                lastEvaluatedKey = result.lastEvaluatedKey;
                setScannedPages((prev) => prev + 1);
              } while (lastEvaluatedKey);
              setFetched(true);
            } catch (error) {
              console.log(error);
            }
            setLoading(false);
          }}
        >
          Get Recently Joined Advisors
        </Button>
        {(loading || fetched) && (
          <Typography>
            {loading ? 'Loading, ' : ''} {scannedPages * 5} scanned pages
          </Typography>
        )}
        {!loading && fetched && (
          <>
            <Typography>
              {totalAdvisors} total advisors created in the last 30 days{' '}
            </Typography>
            <Typography>
              {totalAdvisorsWithRelations} advisors with relations
            </Typography>
          </>
        )}
      </Box>
      <Box>
        <Box margin="20px">
          <Divider orientation="horizontal" sx={{ my: 3 }} />
        </Box>
        <h2>Export Company Advisors</h2>
      </Box>
      <Box>
        <Input type="text" id="companyId" placeholder="companyId" sx={{ mb: 1 }}></Input>
      </Box>
      <Box>
        <Button
          variant="contained"
          color="error"
          disabled={exportLoading}
          sx={{ my: 3 }}
          onClick={async () => {
            try {
              setExportLoading(true);
              const { data } = await getCompanyAdvisorsExport({
                COMPANY_ID: document.getElementById("companyId").value,
              });
              const element = document.createElement("a");
              const file = new Blob([data.exportCompanyAdvisors
              ], { type: 'text/plain' });
              element.href = URL.createObjectURL(file);
              element.download = "export.csv";
              document.body.appendChild(element); // Required for this to work in FireFox
              element.click();
            } catch (error) {
              console.log(error);
            }
            setExportLoading(false);
          }}
        >
          Export
        </Button>
      </Box>
    </Box>
  );
};

export default Stats;
